import { render, staticRenderFns } from "./chart-errors.vue?vue&type=template&id=220d4716"
import script from "./chart-errors.vue?vue&type=script&lang=js"
export * from "./chart-errors.vue?vue&type=script&lang=js"
import style0 from "./chart-errors.vue?vue&type=style&index=0&id=220d4716&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports